import React from 'react';
import './MessageBubble.css';

export default function MessageBubble({ message, isOwn }) {
  const { text, image, username, createdAt } = message;

  const formattedTime = createdAt
    ? new Date(createdAt).toLocaleString()
    : '';

  return (
    <div className={`message-bubble ${isOwn ? 'own' : 'friend'}`}>
      <div className={`tooltip-wrapper ${isOwn ? 'tooltip-left' : 'tooltip-right'}`}>
        {image && (
          <img
            src={image}
            alt="Sent"
            className="message-image"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        )}
        {text && <p className="message-text">{text}</p>}
        <div className="message-tooltip">
          <span> Sent By: <strong>{username || (isOwn ? 'You' : 'Unknown')}</strong></span><br />
          <span>{formattedTime}</span>
        </div>
      </div>
    </div>
  );
}
